/* ===== GENECTRA CALC PRO · JS (assets) ===== */
(() => {
  const root = document.getElementById("gxcalc-pro");
  if(!root || root.dataset.gxInit) return;
  root.dataset.gxInit = "1";

  const bind = (k) => root.querySelector(`[data-bind="${k}"]`);
  const zoneAp = root.querySelector('[data-zone="appliances"]');
  const stMenu = bind("stMenu");
  const stBtn  = root.querySelector(".gxpro__stBtn");

  const warnEl = bind("warn");
  const buyBtn = bind("buyBtn");
  const addonCard = bind("addonCard");
  const covNav = bind("covNav");

  /* ========= IMÁGENES HORIZONTALES (override) ========= */
  const IMG_BIG = window.GXPRO_IMG_BIG || {
    nomad_mini:   "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/nomad_mini.jpg?v=1768591057",
    nomad:        "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/nomad_station.jpg?v=1768594167",
    hope:         "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/hope_power.jpg?v=1768594167",
    adventure:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/adventure.jpg?v=1768594167",
    pathfinder:   "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/pathfinder.jpg?v=1768594167",
    freedom:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/freedom_solar.jpg?v=1768594167",
    titan_power:  "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/titan_power.jpg?v=1768594167"
  };

  function getBigImgOverride(st){
    const raw = (st?.rawTitle || "").toLowerCase();
    const handle = (st?.handle || "").toLowerCase();
    const title = (st?.title || "").toLowerCase();
    const s = `${raw} ${handle} ${title}`;

    if (s.includes("nomad") && s.includes("mini")) return IMG_BIG.nomad_mini;
    if (s.includes("nomad")) return IMG_BIG.nomad;
    if (s.includes("hope")) return IMG_BIG.hope;
    if (s.includes("adventure")) return IMG_BIG.adventure;
    if (s.includes("pathfinder") || s.includes("phatfinder")) return IMG_BIG.pathfinder;
    if (s.includes("freedom")) return IMG_BIG.freedom;
    if (s.includes("titan") && !s.includes("titan x") && !s.includes(" titanx") && !s.includes(" x")) return IMG_BIG.titan_power;

    return null;
  }

  function cleanTitle(t){
    return (t || "")
      .replace(/^\s*estaci[oó]n\s+de\s+energ[ií]a(\s+solar)?\s*/ig, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  /* ========= WH y MAXW ========= */
  function getWhByTitle(titleRaw){
    const t = (titleRaw || "").toLowerCase();
    if (t.includes("nomad") && t.includes("mini")) return 288;
    if (t.includes("nomad")) return 512;
    if (t.includes("adventure")) return 960;
    if (t.includes("pathfinder")) return 2048;
    if (t.includes("hope")) return 1305;
    if (t.includes("freedom")) return 3840;
    if (t.includes("titan")) return 9792;

    if (t.includes("party") || t.includes("armour") || t.includes("armor") || t.includes("solar armour") || t.includes("solar armor")) return 74;
    if (t.includes("power max") || t.includes("powermax") || t.includes("30k") || t.includes("30 k") || t.includes("30000") || t.includes("30.000")) return 111;

    return 0;
  }

  function getMaxWByTitle(titleRaw){
    const t = (titleRaw || "").toLowerCase();
    if (t.includes("nomad") && t.includes("mini")) return 300;
    if (t.includes("nomad")) return 800;
    if (t.includes("adventure")) return 1200;
    if (t.includes("pathfinder")) return 2400;
    if (t.includes("hope")) return 400;
    if (t.includes("freedom")) return 3600;
    if (t.includes("titan")) return 7200;

    if (t.includes("party") || t.includes("armour") || t.includes("armor") || t.includes("powermax") || t.includes("30k") || t.includes("30000")) return 0;
    return 0;
  }

  /* ========= Freedom baterías ========= */
  const FREEDOM_MAX_BATT = 2;
  const FREEDOM_BATT_WH  = 3840;
  let battQty = 0;

  function isFreedom(st){
    const t = (st?.rawTitle || "").toLowerCase();
    const h = (st?.handle || "").toLowerCase();
    return t.includes("freedom") || h.includes("freedom");
  }

  /* ========= Unidades especiales ========= */
  function specialUnitForDevice(name){
    const n = (name||"").toLowerCase();
    // equivalencia energética por unidad (minutos por unidad)
    if(n.includes("secador"))    return { unitLabel:"usos",   minutesPerUnit:60  };
    if(n.includes("cafetera"))   return { unitLabel:"tazas",  minutesPerUnit:60  };
    if(n.includes("lavadora"))   return { unitLabel:"ciclos", minutesPerUnit:60 };
    if(n.includes("smartphone")) return { unitLabel:"cargas", minutesPerUnit:60 };
    if(n.includes("licuadora")) return { unitLabel:"usos", minutesPerUnit:60 };
    if(n.includes("cámara")) return { unitLabel:"cargas", minutesPerUnit:60 };
    if(n.includes("gopro")) return { unitLabel:"cargas", minutesPerUnit:60 };
     if(n.includes("drone")) return { unitLabel:"batería", minutesPerUnit:60 };
    return { unitLabel:"horas", minutesPerUnit:60 };
  }


  /* ========= HINTS de duración para etiquetas (UI) =========
   Editable: agrega/quita matches acá sin tocar DEVICES */
const GXPRO_TILE_HINTS = window.GXPRO_TILE_HINTS || [
  { match: "licuadora", text: "Uso de 3 min" },
  { match: "secador de pelo compacto", text: "Uso de 5 min" },
  { match: "secador de pelo", text: "Uso de 5 min" },
  // si quieres, puedes poner otros:
  // { match: "lavadora", text: "Ciclo de 1 h" },
  // { match: "smartphone", text: "1 carga" },
];

function getTileHintText(name){
  const n = (name || "").toLowerCase();
  const hit = GXPRO_TILE_HINTS.find(h => n.includes(String(h.match).toLowerCase()));
  return hit ? String(hit.text) : "";
}

  /* ========= LABEL (Cov) ========= */
  function devicePowerLabel(d){
  const spec = specialUnitForDevice(d?.name || "");
  const w = Number(d?.watts || 0).toLocaleString("es-CL");

  // base (lo que ya tenías / overrides)
  let base = "";
  if(d?.tileLabel) base = String(d.tileLabel);
  else if(d?.show) base = String(d.show);
  else if(d?.wLabel) base = String(d.wLabel);
  else {
    if(!spec || spec.unitLabel === "horas"){
      base = `${w} Watts`;
    } else {
      const per =
        (spec.unitLabel === "usos")   ? "uso"   :
        (spec.unitLabel === "tazas")  ? "taza"  :
        (spec.unitLabel === "cargas") ? "carga" :
        (spec.unitLabel === "ciclos") ? "ciclo" :
        spec.unitLabel;
      base = `${w} Watts por ${per}`;
    }
  }

  // ✅ hint "Uso de X min" (para especiales) incluso si hay tileLabel/show/wLabel,
  // pero evita duplicar si ya viene con "min"
  if(spec && spec.unitLabel && spec.unitLabel !== "horas"){
    const hint = getTileHintText(d?.name || "");
    if(hint && !base.toLowerCase().includes("min")){
      return `${hint} · ${base}`;
    }
  }

  return base;
}


  /* ========= LABEL (Auto) · Qty dinámico ========= */
  function baseNameForQty(name){
    let s = String(name || "").trim();

    // toma lo "principal": antes de paréntesis y antes de " / "
    s = s.split("(")[0].trim();
    s = s.split(" / ")[0].trim();
    s = s.split("/")[0].trim();

    // limpia dobles espacios
    s = s.replace(/\s+/g, " ").trim();
    return s || "equipo";
  }

  function pluralizeEsPhrase(phrase){
    const p = String(phrase || "").trim();
    if(!p) return p;
    const parts = p.split(" ");
    const last = parts.pop();
    const plLast = pluralizeEsWord(last);
    parts.push(plLast);
    return parts.join(" ");
  }

  function pluralizeEsWord(word){
    const w = String(word || "").trim();
    if(!w) return w;

    // sigla/uppercase (LED, TV, CPAP, XBOX, etc)
    const isAcronym = (w.toUpperCase() === w) && /[A-ZÁÉÍÓÚÜÑ]/.test(w);
    if(isAcronym){
      if(w.endsWith("S")) return w;
      return w + "s"; // TV -> TVs, CPAP -> CPAPs
    }

    const lower = w.toLowerCase();

    // ya plural típico
    if(lower.endsWith("s") || lower.endsWith("x")) return w;

    // z -> ces
    if(lower.endsWith("z")){
      return w.slice(0, -1) + "ces";
    }

    // vocal -> +s
    if(/[aeiouáéíóúü]$/i.test(w)){
      return w + "s";
    }

    // consonante -> +es
    return w + "es";
  }

function autoQtyLabel(d, qty){
  const q = Number(qty || 0);
  if(q <= 0) return "—";

  const w = Number(d?.watts || 0);
  const wTxt = w ? ` ~ ${w.toLocaleString("es-CL")} Watts` : "";

  const spec = specialUnitForDevice(d?.name);

  let suffix = "";
  if(spec && spec.unitLabel && spec.unitLabel !== "horas"){
    const per =
      spec.unitLabel === "usos"   ? "uso"   :
      spec.unitLabel === "cargas" ? "carga" :
      spec.unitLabel === "ciclos" ? "ciclo" :
      spec.unitLabel === "tazas"  ? "taza"  :
      spec.unitLabel;
    suffix = ` por ${per}`;
  } else {
    suffix = (q > 1) ? " c/u" : "";
  }

  const sel = (q === 1) ? "seleccionado" : "seleccionados";
  return `${q} ${sel}${wTxt}${suffix}`;
}



  /* ========= Icono por aparato (IMG Shopify) ========= */
  function emojiForDevice(name){
    const n = (name||"").toLowerCase();

    const ICONS = window.GXPRO_DEVICE_ICONS || {
      notebook:   "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_notebook.svg?v=1778620125",
      tv:         "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_tv.svg?v=1778621180",
      router:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_router.svg?v=1778620126",
      light:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_ampolleta.svg?v=1778620125",
      microwave:  "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_microondas.svg?v=1778620126",
      fridge:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_refrigerador.svg?v=1778620125",
      fan:        "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_ac.svg?v=1778620150",
      drill:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_taladro.svg?v=1778620125",
      saw:        "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_esmeril.svg?v=1778620126",
      blender:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_licuadora.svg?v=1778622794",
      kettle:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/38.webp?v=1770823699",
      dryer:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_lavadora.svg?v=1778622794",
      iron:       "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_plancha.svg?v=1778620125",
      cpap:       "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_cpap.svg?v=1778620126",
      ac:         "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_ac.svg?v=1778620150",
      heater:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_starlink.svg?v=1778620126",
      starlink:   "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/26.webp?v=1770817802",
      speaker:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_parlante.svg?v=1778620126",
      projector:  "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_proyector.svg?v=1778620126",
      radio:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_parlante.svg?v=1778620126",
      pump:       "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_bomba.svg?v=1778620125",
      washer:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_lavadora.svg?v=1778622794",
      vacuum:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_aspiradora.svg?v=1778620126",
      console:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_consola.svg?v=1778620126",
      camera:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_camara.svg?v=1778620126",
      drone:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_drone.svg?v=1778622793",
      phone:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_smartphone.svg?v=1778620125",
      coffee:     "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_cafetera.svg?v=1778620125",
      toolbox:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_bomba.svg?v=1778620125",
      pc:          "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/pc_normal.webp?v=1770909143",
      gopro:      "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_gopro.svg?v=1778620126",
      airfryer:  "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/8.webp?v=177081780202",
      decoder:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_tv.svg?v=1778621180",
      desk_lamp:  "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_lampara.svg?v=1778620126",
      flashlight: "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/autonomia_linterna.svg?v=1778620126",

      default:    "https://cdn.shopify.com/s/files/1/0593/6198/4574/files/default.webp?v=1770825714"
    };

    const img = (src) =>
      src
        ? `<img src="${src}" alt="" loading="lazy" width="28" height="28" decoding="async">`
        : "🔌";

    if(n.includes("freidora")) return img(ICONS.airfryer);
    if(n.includes("decodificador")) return img(ICONS.decoder);
    if(n.includes("lámpara de escritorio") || n.includes("lampara de escritorio")) return img(ICONS.desk_lamp);
    if(n.includes("linterna")) return img(ICONS.flashlight);
    if(n.includes("pc")) return img(ICONS.pc);
    if(n.includes("notebook") || n.includes("laptop")) return img(ICONS.notebook);
    if(n.includes("tv")) return img(ICONS.tv);
    if(n.includes("router")) return img(ICONS.router);
    if(n.includes("ampolleta") || n.includes("lámpara") || n.includes("lampara") || n.includes("luces")) return img(ICONS.light);
    if(n.includes("microondas")) return img(ICONS.microwave);
    if(n.includes("refrigerador") || n.includes("frigobar") || n.includes("nevera")) return img(ICONS.fridge);
    if(n.includes("ventilador")) return img(ICONS.fan);
    if(n.includes("taladro") || n.includes("rotomartillo")) return img(ICONS.drill);
    if(n.includes("sierra")) return img(ICONS.saw);
    if(n.includes("licuadora")) return img(ICONS.blender);
    if(n.includes("hervidor")) return img(ICONS.kettle);
    if(n.includes("secador")) return img(ICONS.dryer);
    if(n.includes("plancha")) return img(ICONS.iron);
    if(n.includes("cpap")) return img(ICONS.cpap);
    if(n.includes("aire acondicionado")) return img(ICONS.ac);
    if(n.includes("estufa") || n.includes("horno") || n.includes("calefactor")) return img(ICONS.heater);
    if(n.includes("starlink") || n.includes("sat")) return img(ICONS.starlink);
    if(n.includes("parlante")) return img(ICONS.speaker);
    if(n.includes("proyector")) return img(ICONS.projector);
    if(n.includes("radio")) return img(ICONS.radio);
    if(n.includes("bomba de agua")) return img(ICONS.pump);
    if(n.includes("lavadora")) return img(ICONS.washer);
    if(n.includes("aspiradora")) return img(ICONS.vacuum);
    if(n.includes("consola")) return img(ICONS.console);
    if(n.includes("cámara") || n.includes("camara")) return img(ICONS.camera);
    if(n.includes("GoPro") || n.includes("gopro")) return img(ICONS.gopro);
    if(n.includes("drone")) return img(ICONS.drone);
    if(n.includes("smartphone")) return img(ICONS.phone);
    if(n.includes("cafetera")) return img(ICONS.coffee);
    if(n.includes("amoladora") || n.includes("lijadora") || n.includes("compresor")) return img(ICONS.toolbox);

    return img(ICONS.default);
  }

  /* ========= DEVICES ========= */
  const DEVICES = window.GXPRO_DEVICES || [
    {name:'Aire Acondicionado (Inverter)', watts:900, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Aire Acondicionado (Tradicional, no inverter)', watts:1500, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Amoladora angular', watts:1200, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Ampolleta LED', watts:10, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Aspiradora', watts:1900, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Bomba de agua 1 hp', watts:850, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Bomba de agua 0,5 hp', watts:600, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Bomba de agua 1,5 hp', watts:1500, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Bomba de agua 2 hp', watts:2000, allowed:['Freedom','Freedom1','Freedom2','Titan']},
    {name:'Cafetera (1 taza)', watts:83, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Cámara', watts:16, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Compresor portátil 12V', watts:150, allowed:['Nomad','Adventure','Hope','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Compresor portátil 1HP', watts:1000, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Compresor portátil 1HP', watts:1800, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Consola de videojuegos (PS5 / XBOX SERIES X)', watts:200, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'CPAP (humidificador)', watts:90, allowed:['Adventure','Hope','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'CPAP (sin humidificador)', watts:60, allowed:['Adventure','Hope','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Decodificador de TV', watts:15, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Drone', watts:45, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Estufa eléctrica', watts:2000, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Freidora de aire', watts:1600, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'GoPro', watts:10, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Hervidor', watts:2100, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Horno', watts:2200, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Lámpara de escritorio', watts:10, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Lavadora (agua caliente)', watts:1500, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Lavadora (agua fría)', watts:600, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Licuadora (uso 3 min)', watts:42, excludeNomadMini:true, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Lijadora orbital', watts:400, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Linterna LED', watts:10, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Microondas', watts:1500, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Notebook', watts:65, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Notebook Gamer', watts:100, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Parlante bluetooth grande', watts:150, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'PC de Oficina', watts:250, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'PC Gamer', watts:600, excludeNomadMini:true, allowed:['Nomad','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Plancha de ropa', watts:2000, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Proyector', watts:250, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Radio Portátil', watts:6, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Refrigerador pequeño / frigobar / nevera pequeña', watts:55, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Refrigerador doble puerta / nevera', watts:100, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Rotomartillo', watts:1100, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Router WiFi', watts:12, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Starlink (estándar)', watts:50, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Starlink Mini', watts:25, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Secador de Pelo (uso 5 min)', watts:167, tileLabel:'Uso de 5 min (~167 watts)', allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Secador de Pelo Compacto (uso 5 min)', watts:83, tileLabel:'Uso de 5 min (~83 watts)', allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Sierra circular', watts:1500, allowed:['Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Smartphone', watts:18, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Party','PowerMax','Titan']},
    {name:'Taladro doméstico', watts:900, allowed:['Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'TV', watts:85, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
    {name:'Ventilador', watts:100, allowed:['Nomad','Hope','Adventure','Pathfinder','Freedom','Freedom1','Freedom2','Titan']},
  ];

  const PER_PAGE = 12;
  let apPage = 0;

  /* ========= Estado por pestaña ========= */
  let mode = "auto";        // auto | cov
  let covStep = "pick";     // pick | usage | stations

  const qtyAuto = new Map(); // idx -> qty (solo autonomía)
  const cov = new Map();     // idx -> { qty, units, unitLabel, minutesPerUnit } (solo cobertura)

  /* ========= Stations list (desde tu HTML) ========= */
  const EXCLUDE_WORDS = ["batería","bateria","battery","expansion","extension","add-on","addon","pack","módulo","modulo"];
  Array.from(root.querySelectorAll("[data-st-item]")).forEach(btn => {
    const rawTitle = (btn.getAttribute("data-title")||"").toLowerCase();
    const handle = (btn.getAttribute("data-handle")||"").toLowerCase();
    const bad = EXCLUDE_WORDS.some(w => rawTitle.includes(w) || handle.includes(w));
    if(bad) btn.remove();
  });

  const stBtns = Array.from(root.querySelectorAll("[data-st-item]"));
  stBtns.forEach(btn => {
    const raw = btn.getAttribute("data-title") || "";
    const ct = cleanTitle(raw) || raw;
    btn.dataset.cleanTitle = ct;
    const titleEl = btn.querySelector(".gxpro__stTitle");
    if(titleEl) titleEl.textContent = ct;
  });

  let stSelected = stBtns[0] || null;

  function stationData(el){
    if(!el) return null;
    const rawTitle = el.getAttribute("data-title") || "—";
    const title = el.dataset.cleanTitle || cleanTitle(rawTitle) || rawTitle;
    const handle = (el.getAttribute("data-handle") || "").toLowerCase();
    return {
      title, rawTitle, handle,
      wh: getWhByTitle(rawTitle),
      maxW: getMaxWByTitle(rawTitle),
      url: el.getAttribute("data-url") || "/collections/estaciones-de-energia-solar",
      img: el.getAttribute("data-img") || ""
    };
  }

  function stationKeyFromRaw(rawTitle, handle, title){
    const s = `${rawTitle||""} ${handle||""} ${title||""}`.toLowerCase();
  if (s.includes("nomad") && s.includes("mini")) return "NomadMini";
if (s.includes("nomad")) return "Nomad";
    if (s.includes("hope")) return "Hope";
    if (s.includes("adventure")) return "Adventure";
    if (s.includes("pathfinder") || s.includes("phatfinder")) return "Pathfinder";
    if (s.includes("freedom")) return "Freedom";
    if (s.includes("titan")) return "Titan";
    if (s.includes("party") || s.includes("armour") || s.includes("armor")) return "Party";
    if (s.includes("power max") || s.includes("powermax") || s.includes("30k") || s.includes("30000")) return "PowerMax";
    return "Nomad";
  }

  function stationKey(st){
    return stationKeyFromRaw(st?.rawTitle, st?.handle, st?.title);
  }

function allowedForStation(device, stKey){
  const deviceAllowed = device?.allowed;
  if(!deviceAllowed) return true;

  // Freedom: sigue igual (compat con Freedom1/Freedom2)
  if(stKey === "Freedom"){
    return deviceAllowed.includes("Freedom") || deviceAllowed.includes("Freedom1") || deviceAllowed.includes("Freedom2");
  }

  // NomadMini: por defecto acepta lo que acepte "Nomad", salvo que el equipo lo bloquee
  if(stKey === "NomadMini"){
    if(deviceAllowed.includes("NomadMini")) return true;
    if(deviceAllowed.includes("Nomad") && !device.excludeNomadMini) return true;
    return false;
  }

  return deviceAllowed.includes(stKey);
}


  function getFilteredIndexes(){
    if(mode === "cov"){
      return DEVICES.map((_, i)=>i);
    }
    const st = stationData(stSelected);
    const stKey = stationKey(st);
    const idxs = [];
 DEVICES.forEach((d, i) => { if(allowedForStation(d, stKey)) idxs.push(i); });
    return idxs;
  }

  function formatHours(hoursFloat){
    if (hoursFloat <= 0) return '0 min';
    const h = Math.floor(hoursFloat);
    let m = Math.round((hoursFloat - h) * 60);
    if (m === 60){ m = 0; return (h+1) + ' h'; }
    if (h > 0 && m > 0) return `${h} h ${m} min`;
    if (h > 0 && m === 0) return `${h} h`;
    return `${m} min`;
  }

  function openMenu(){ stMenu.hidden = false; stBtn.setAttribute("aria-expanded","true"); }
  function closeMenu(){ stMenu.hidden = true; stBtn.setAttribute("aria-expanded","false"); }
  function toggleMenu(){ stMenu.hidden ? openMenu() : closeMenu(); }

  /* ========= UI Cobertura ========= */
  const devicesSection = root.querySelector(".gxpro__devices");
  let covHelp = bind("covHelp");
  if(!covHelp && devicesSection){
    covHelp = document.createElement("div");
    covHelp.setAttribute("data-bind","covHelp");
    covHelp.className = "gxpro__covHelp";
    const head = root.querySelector(".gxpro__devicesHead");
    if(head) head.insertAdjacentElement("afterend", covHelp);
  }

  let covPanel = bind("covPanel");
  if(!covPanel && devicesSection){
    covPanel = document.createElement("div");
    covPanel.setAttribute("data-bind","covPanel");
    covPanel.className = "gxpro__covPanel";
    covPanel.innerHTML = `
      <div class="gxpro__covTitle">PASO 2: CANTIDAD + HORAS / CARGAS / CICLOS / TAZAS / USOS</div>
      <div class="gxpro__covCards" data-bind="covCards"></div>
      <div class="gxpro__covHint">Define el uso por cada aparato seleccionado.</div>
    `;
    devicesSection.appendChild(covPanel);
  }
  const covCards = bind("covCards");

  let covStationsPanel = bind("covStationsPanel");
  let covPlanBox = bind("covPlanBox");
  if(!covStationsPanel && devicesSection){
    covStationsPanel = document.createElement("div");
    covStationsPanel.setAttribute("data-bind","covStationsPanel");
    covStationsPanel.className = "gxpro__covStations";
    covStationsPanel.innerHTML = `
      <div class="gxpro__covTitle">PASO 3: RESULTADO</div>
      <div class="gxpro__covPlanBox" data-bind="covPlanBox"></div>
      <div class="gxpro__covStationsGrid" data-bind="covStationsGrid"></div>
    `;
    devicesSection.appendChild(covStationsPanel);
    covPlanBox = bind("covPlanBox");
  }
  const covStationsGrid = bind("covStationsGrid");

  /* ========= Autonomía: meta de estación (Wh / W) ========= */
  let stMetaEl = root.querySelector(".gxpro__stMeta");
  if(!stMetaEl){
    const stationInner = root.querySelector(".gxpro__stationInner");
    const resultWrap = root.querySelector(".gxpro__resultWrap");
    if(stationInner){
      stMetaEl = document.createElement("div");
      stMetaEl.className = "gxpro__stMeta";
      stMetaEl.setAttribute("data-bind","stMeta");
      stMetaEl.innerHTML = `<span>Capacidad: <b>—</b></span><span>Potencia máx: <b>—</b></span>`;
      if(resultWrap) stationInner.insertBefore(stMetaEl, resultWrap);
      else stationInner.appendChild(stMetaEl);
    }
  }

  function updateStationMeta(){
    if(!stMetaEl) return;
    const st = stationData(stSelected);
    if(!st){ stMetaEl.innerHTML = `<span>Capacidad: <b>—</b></span><span>Potencia máx: <b>—</b></span>`; return; }

    let whTotal = st.wh || 0;
    if(isFreedom(st)) whTotal += battQty * FREEDOM_BATT_WH;

    const cap = whTotal ? `${Math.round(whTotal).toLocaleString("es-CL")} Wh` : "—";
    const pmax = st.maxW ? `${st.maxW.toLocaleString("es-CL")} Watts` : "—";

    stMetaEl.innerHTML = `
      <span>Capacidad: <b>${cap}</b></span>
      <span>Potencia máx: <b>${pmax}</b></span>
    `;
  }

  /* ========= Pager helpers + swipe ========= */
  function goPrevPage(){
    const idxs = getFilteredIndexes();
    const totalPages = Math.max(1, Math.ceil(idxs.length / PER_PAGE));
    apPage = (apPage - 1 + totalPages) % totalPages;
    renderAppliances();
  }
  function goNextPage(){
    const idxs = getFilteredIndexes();
    const totalPages = Math.max(1, Math.ceil(idxs.length / PER_PAGE));
    apPage = (apPage + 1) % totalPages;
    renderAppliances();
  }

  function attachSwipePager(){
    if(!zoneAp) return;
    let down = false, startX = 0, lastX = 0;
    const threshold = 40;
    const onDown = (x) => { down = true; startX = x; lastX = x; };
    const onMove = (x) => { if(!down) return; lastX = x; };
    const onUp = () => {
      if(!down) return;
      down = false;
      const dx = lastX - startX;
      if(Math.abs(dx) < threshold) return;
      if(dx < 0) goNextPage(); else goPrevPage();
    };
    zoneAp.addEventListener("touchstart",(e)=>onDown(e.touches[0].clientX),{passive:true});
    zoneAp.addEventListener("touchmove",(e)=>onMove(e.touches[0].clientX),{passive:true});
    zoneAp.addEventListener("touchend",()=>onUp());
    zoneAp.addEventListener("mousedown",(e)=>onDown(e.clientX));
    window.addEventListener("mousemove",(e)=>onMove(e.clientX));
    window.addEventListener("mouseup",()=>onUp());
  }

  function covHasSelection(){
    for (const v of cov.values()){
      if((v?.qty||0) > 0) return true;
    }
    return false;
  }

  function covHelpText(){
    if(covStep === "pick") return "Paso 1: escoge los aparatos que vas a utilizar. Cuando termines, presiona “Siguiente”.";
    if(covStep === "usage") return "Paso 2: define cantidad y horas / cargas / ciclos / tazas / usos por cada aparato.";
    return "Paso 3: estas estaciones cubren tu consumo. Entra al link para ver/comprar.";
  }

  function setRootCovStepClass(){
    root.classList.remove("gxpro--cov-step-pick","gxpro--cov-step-usage","gxpro--cov-step-stations");
    if(mode !== "cov") return;
    if(covStep === "pick") root.classList.add("gxpro--cov-step-pick");
    if(covStep === "usage") root.classList.add("gxpro--cov-step-usage");
    if(covStep === "stations") root.classList.add("gxpro--cov-step-stations");
  }

  function updateCovUI(){
    if(!covNav) return;

    const on = (mode === "cov");
    covNav.hidden = !on;

    if(covHelp){
      covHelp.hidden = !on;
      if(on) covHelp.textContent = covHelpText();
    }

    const nextBtn = covNav.querySelector('[data-action="covNext"]');
    const backBtn = covNav.querySelector('[data-action="covBack"]');

    if(mode === "cov"){
      root.classList.add("gxpro--cov");
      if(warnEl) warnEl.hidden = true;
      if(buyBtn) buyBtn.classList.add("is-disabled");
      const autoOut = bind("autoOut"); if(autoOut) autoOut.hidden = true;
      const covOut  = bind("covOut");  if(covOut)  covOut.hidden  = true;
    }else{
      root.classList.remove("gxpro--cov");
      if(buyBtn) buyBtn.classList.remove("is-disabled");
    }

    if(!on){
      if(covPanel) covPanel.hidden = true;
      if(covStationsPanel) covStationsPanel.hidden = true;
      if(backBtn) backBtn.hidden = true;
      if(nextBtn){ nextBtn.disabled = true; nextBtn.textContent = "Siguiente"; }
      setRootCovStepClass();
      return;
    }

    if(covStep === "pick"){
      if(covPanel) covPanel.hidden = true;
      if(covStationsPanel) covStationsPanel.hidden = true;
      if(backBtn) backBtn.hidden = true;
      if(nextBtn){ nextBtn.disabled = !covHasSelection(); nextBtn.textContent = "Siguiente"; }
      setRootCovStepClass();
      return;
    }

    if(covStep === "usage"){
      if(covPanel) covPanel.hidden = false;
      if(covStationsPanel) covStationsPanel.hidden = true;
      if(backBtn) backBtn.hidden = false;
      if(nextBtn){ nextBtn.disabled = false; nextBtn.textContent = "Ver estaciones"; }
      setRootCovStepClass();
      return;
    }

    if(covStep === "stations"){
      if(covPanel) covPanel.hidden = true;
      if(covStationsPanel) covStationsPanel.hidden = false;
      if(backBtn) backBtn.hidden = false;
      if(nextBtn){ nextBtn.disabled = true; nextBtn.textContent = "Listo"; }
      setRootCovStepClass();
    }
  }

  function renderAppliances(){
    const idxs = getFilteredIndexes();
    const totalPages = Math.max(1, Math.ceil(idxs.length / PER_PAGE));
    apPage = ((apPage % totalPages) + totalPages) % totalPages;

    const apPageEl = bind("apPage");
    const apTotalEl = bind("apTotal");
    if(apPageEl) apPageEl.textContent = String(apPage + 1);
    if(apTotalEl) apTotalEl.textContent = String(totalPages);

    const start = apPage * PER_PAGE;
    const slice = idxs.slice(start, start + PER_PAGE);

    zoneAp.innerHTML = "";

    slice.forEach(i => {
      const d = DEVICES[i];
      const emoji = emojiForDevice(d.name);

      const v = (mode === "auto")
        ? (qtyAuto.get(i) || 0)
        : (cov.get(i)?.qty || 0);

      const tileText = (mode === "auto")
        ? autoQtyLabel(d, v)
        : devicePowerLabel(d);

      const el = document.createElement("div");
      el.className = "gxpro__tile" + (v > 0 ? " is-on" : "");
      el.setAttribute("data-idx", String(i));

      el.innerHTML = `
        <div class="gxpro__emoji" aria-hidden="true">${emoji}</div>
        <div class="gxpro__tName">${d.name}</div>
        <div class="gxpro__tW" data-bind="tw-${i}">${tileText}</div>

        <div class="gxpro__stepper2" aria-label="Cantidad">
          <button class="gxpro__sbtn" type="button" data-action="decQty">−</button>
          <div class="gxpro__sval" data-bind="v-${i}">${v}</div>
          <button class="gxpro__sbtn" type="button" data-action="incQty">+</button>
        </div>
      `;
      zoneAp.appendChild(el);
    });
  }

  function renderCovUsageCards(){
    if(!covCards) return;

    if(!(mode === "cov" && covStep === "usage")){
      covCards.innerHTML = "";
      return;
    }

    const list = Array.from(cov.entries())
      .map(([idx, v]) => {
        const d = DEVICES[idx];
        const spec = specialUnitForDevice(d.name);
        return {
          idx:Number(idx),
          d,
          qty:Number(v.qty||0),
          units:Number(v.units||1),
          unitLabel: v.unitLabel || spec.unitLabel,
          minutesPerUnit: Number(v.minutesPerUnit || spec.minutesPerUnit || 60)
        };
      })
      .filter(x => x.qty > 0)
      .sort((a,b)=>a.d.name.localeCompare(b.d.name));

    covCards.innerHTML = "";

    if(list.length === 0){
      covCards.innerHTML = `<div class="gxpro__covCard" style="opacity:.65;font-weight:900">No has seleccionado aparatos.</div>`;
      return;
    }

    list.forEach(item=>{
      const card = document.createElement("div");
      card.className = "gxpro__covCard";
      card.setAttribute("data-cov-idx", String(item.idx));

      card.innerHTML = `
        <div class="gxpro__covTop">
          <div class="gxpro__covLeft">
            <div class="gxpro__covIcon" aria-hidden="true">${emojiForDevice(item.d.name)}</div>
            <div>
              <div class="gxpro__covName">${item.d.name}</div>
              <div class="gxpro__covMeta">${devicePowerLabel(item.d)} · ${item.qty} equipo(s)</div>
            </div>
          </div>
          <button class="gxpro__covRm" type="button" data-action="covRm">Quitar</button>
        </div>

        <div class="gxpro__covControls">
          <div class="gxpro__field">
            <div class="gxpro__label">Cantidad</div>
            <div class="gxpro__stepper2">
              <button class="gxpro__sbtn" type="button" data-action="covDec">−</button>
              <div class="gxpro__sval" data-bind="covQty">${item.qty}</div>
              <button class="gxpro__sbtn" type="button" data-action="covInc">+</button>
            </div>
          </div>

          <div class="gxpro__field">
            <div class="gxpro__label">Uso (${item.unitLabel})</div>
            <div class="gxpro__stepper2">
              <button class="gxpro__sbtn" type="button" data-action="useDec">−</button>
              <div class="gxpro__sval" data-bind="useVal">${item.units}</div>
              <button class="gxpro__sbtn" type="button" data-action="useInc">+</button>
            </div>
            <div class="gxpro__pill">${item.unitLabel}</div>
          </div>
        </div>
      `;
      covCards.appendChild(card);
    });
  }

  function computeCoverageNeed(){
    let needWh = 0;
    let needW  = 0;

    Array.from(cov.entries())
      .map(([idx, v]) => ({ idx:Number(idx), v, d:DEVICES[idx] }))
      .filter(x => (x.v?.qty||0) > 0 && (x.v?.units||0) > 0)
      .forEach(x => {
        const qty = Number(x.v.qty || 0);
        const units = Number(x.v.units || 0);

        const spec = specialUnitForDevice(x.d.name);
        const minutesPerUnit = Number(
          (x.v.minutesPerUnit != null ? x.v.minutesPerUnit : spec.minutesPerUnit) || 60
        );

        const hoursEq = (minutesPerUnit / 60) * units;

        needWh += x.d.watts * qty * hoursEq;
        needW  += x.d.watts * qty;
      });

    return { needWh: Math.round(needWh), needW: Math.round(needW) };
  }

  function stationAllowsSelection(stKey){
    for(const [idx, v] of cov.entries()){
      if((v?.qty||0) <= 0) continue;
      const d = DEVICES[idx];
      if(!allowedForStation(d, stKey)) return false;
    }
    return true;
  }

  function renderCovStations(){
    if(!covStationsGrid) return;
    if(!(mode === "cov" && covStep === "stations")){
      covStationsGrid.innerHTML = "";
      if(covPlanBox) covPlanBox.innerHTML = "";
      return;
    }

    const { needWh, needW } = computeCoverageNeed();
    covStationsGrid.innerHTML = "";

    const planItems = Array.from(cov.entries())
      .map(([idx, v]) => ({ idx:Number(idx), v, d:DEVICES[idx] }))
      .filter(x => (x.v?.qty||0) > 0 && (x.v?.units||0) > 0)
      .map(x => {
        const spec = specialUnitForDevice(x.d.name);
        const unitLabel = x.v.unitLabel || spec.unitLabel || "horas";
        const qty = Number(x.v.qty||0);
        const units = Number(x.v.units||0);
        return `${x.d.name}: ${qty} equipo(s) · ${units} ${unitLabel}`;
      });

    if(covPlanBox){
      if(planItems.length){
        covPlanBox.innerHTML = `
          <div style="font-weight:900;margin-bottom:6px">Para tu plan que contempla:</div>
          <div style="opacity:.95">${planItems.join(", ")}</div>
          <div style="margin-top:10px;font-weight:900">Las estaciones de energía que te sirven serían:</div>
        `;
      }else{
        covPlanBox.innerHTML = `<div style="opacity:.75;font-weight:900">Selecciona aparatos y define uso para ver estaciones.</div>`;
      }
    }

    if(needWh <= 0){
      covStationsGrid.innerHTML = `<div class="gxpro__covCard" style="opacity:.65;font-weight:900">Selecciona aparatos y define uso para ver estaciones.</div>`;
      return;
    }

    const stationVariants = [];
    stBtns.forEach(btn=>{
      const st = stationData(btn);
      if(!st) return;

      const key = stationKey(st);

      stationVariants.push({
        title: st.title,
        rawTitle: st.rawTitle,
        handle: st.handle,
        key,
        url: st.url,
        img: getBigImgOverride(st) || st.img,
        whTotal: st.wh,
        maxW: st.maxW
      });

      if(key === "Freedom"){
        stationVariants.push({
          title: `${st.title} + 1 batería`,
          rawTitle: st.rawTitle,
          handle: st.handle,
          key,
          url: st.url,
          img: getBigImgOverride(st) || st.img,
          whTotal: st.wh + 1*FREEDOM_BATT_WH,
          maxW: st.maxW
        });
        stationVariants.push({
          title: `${st.title} + 2 baterías`,
          rawTitle: st.rawTitle,
          handle: st.handle,
          key,
          url: st.url,
          img: getBigImgOverride(st) || st.img,
          whTotal: st.wh + 2*FREEDOM_BATT_WH,
          maxW: st.maxW
        });
      }
    });

    const winners = stationVariants.filter(s => {
      const okWh = (s.whTotal >= needWh);
      const okW  = (s.maxW <= 0) ? true : (s.maxW >= needW);
      const okAllowed = stationAllowsSelection(s.key);
      return okWh && okW && okAllowed;
    });

    if(winners.length === 0){
      covStationsGrid.innerHTML = `<div class="gxpro__covCard" style="opacity:.65;font-weight:900">Ninguna estación cubre este consumo (por Wh, W máx. o compatibilidad de aparatos).</div>`;
      return;
    }

    winners.sort((a,b)=> (a.whTotal - b.whTotal));

    winners.forEach(s => {
      const whRest = Math.max(0, Math.round(s.whTotal - needWh));
      const pctRest = s.whTotal > 0 ? Math.round((whRest / s.whTotal) * 100) : 0;

      const card = document.createElement("div");
      card.className = "gxpro__stationPick";
      card.innerHTML = `
        <div class="gxpro__stationPickImgWrap">
          <img class="gxpro__stationPickImg" src="${s.img}" alt="${s.title}">
        </div>
        <div class="gxpro__stationPickTitle">${s.title}</div>
        <div class="gxpro__stationPickMeta">${Math.round(s.whTotal).toLocaleString("es-CL")} Wh · ${s.maxW ? s.maxW.toLocaleString("es-CL") : "—"} W máx.</div>
        <div class="gxpro__stationPickAuto">Batería restante aprox: ${whRest.toLocaleString("es-CL")} Wh (${pctRest}%)</div>
        <a class="gxpro__stationPickBtn" href="${s.url}">Ver estación</a>
      `;
      covStationsGrid.appendChild(card);
    });
  }

  function computeAuto(){
    const st = stationData(stSelected) || {wh:0,maxW:0,title:"—",rawTitle:"",handle:"",img:"",url:"#"};
    let whTotal = st.wh || 0;
    if(isFreedom(st)) whTotal += battQty * FREEDOM_BATT_WH;

    const autoOut = bind("autoOut");
    const covOut  = bind("covOut");

    if(mode !== "auto"){
      if(autoOut) autoOut.hidden = true;
      if(covOut) covOut.hidden = true;
      if(warnEl) warnEl.hidden = true;
      return;
    }

    if(covOut) covOut.hidden = true;
    if(autoOut) autoOut.hidden = false;

    const items = [];
    qtyAuto.forEach((q, idx) => { if(q > 0) items.push({ idx, q }); });

    const autoText = bind("autoText");
    if(items.length === 0 || !whTotal){
      if(autoText) autoText.textContent = "--";
      if(warnEl) warnEl.hidden = true;
      return;
    }

    let totalW = 0;
    items.forEach(it => { totalW += DEVICES[it.idx].watts * it.q; });

    const overload = (st.maxW > 0 && totalW > st.maxW);
    if(warnEl) warnEl.hidden = !overload;

    function formatAutoUsage(d, hoursFloat){
      const spec = specialUnitForDevice(d.name);
      if(!spec || spec.unitLabel === "horas"){
        return formatHours(hoursFloat);
      }
      const minutesPerUnit = Number(spec.minutesPerUnit || 60);
      const unitsFloat = (hoursFloat * 60) / minutesPerUnit;

      const unitsInt = Math.max(0, Math.floor(unitsFloat + 1e-9));
      if(unitsInt <= 0) return `< 1 ${spec.unitLabel}`;
      return `${unitsInt} ${spec.unitLabel}`;
    }

    let out = "";
    let simultaneous = "";
    const typesCount = items.length;

items.forEach(it => {
  const d = DEVICES[it.idx];
  const q = Number(it.q || 0);

  const hoursBase = whTotal / (d.watts * q);
  const hoursSimul = hoursBase / typesCount;

  const base = baseNameForQty(d?.name);
  const label = (q === 1) ? base : pluralizeEsPhrase(base);

  out += `• ${q} ${label}: ${formatAutoUsage(d, hoursBase)}\n`;
  simultaneous += `• ${q} ${label}: ${formatAutoUsage(d, hoursSimul)}\n`;
});


    const totalWtxt = `⚡ Potencia total seleccionada: ${Math.round(totalW).toLocaleString("es-CL")} W\n\n`;

let resultText = `${totalWtxt}🔋 Uso individual (capacidad completa):\n${out}`;

    if(typesCount > 1){
      resultText += `\n\n⏳ Uso simultáneo (capacidad repartida):\n${simultaneous}`;
    }

    if(autoText) autoText.textContent = resultText;
  }

  function setMode(next){
    mode = next;

    const legend = bind("legend");
    if(legend){
      legend.textContent = (mode === "auto")
        ? "Te ayudamos a estimar la duración con tu estación Genectra."
        : "Cobertura en simultáneo (tipo test): aparatos → uso → estaciones que cubren.";
    }

    if(mode === "cov"){
      covStep = "pick";
      root.classList.add("gxpro--cov");
      if(warnEl) warnEl.hidden = true;
      if(buyBtn) buyBtn.classList.add("is-disabled");
    } else {
      root.classList.remove("gxpro--cov");
      if(buyBtn) buyBtn.classList.remove("is-disabled");
    }

    apPage = 0;
    renderAppliances();
    renderCovUsageCards();
    renderCovStations();
    updateCovUI();
    computeAuto();
    updateStationMeta();
  }

  function setStation(btn){
    stSelected = btn;
    stBtns.forEach(x => x.classList.toggle("is-active", x === btn));

    const st = stationData(btn);
    if(!st) return;

    const big = getBigImgOverride(st);
    const stImg = bind("stImg");
    if(stImg){
      stImg.src = big || st.img;
      stImg.alt = st.title;
    }

    const stBtnText = bind("stBtnText");
    if(stBtnText) stBtnText.textContent = st.title;

    battQty = 0;
    const qtyEl = bind("qty");
    if(qtyEl) qtyEl.textContent = "0";
    if(addonCard) addonCard.hidden = !isFreedom(st);

    if(buyBtn){
      buyBtn.href = st.url;
      buyBtn.classList.remove("is-disabled");
      buyBtn.removeAttribute("aria-disabled");
    }

    apPage = 0;
    renderAppliances();
    updateCovUI();
    computeAuto();
    updateStationMeta();
  }

  root.addEventListener("click", (e) => {
    const t = e.target;
    const act = t.getAttribute("data-action") || t.closest("[data-action]")?.getAttribute("data-action");

    const tab = t.closest(".gxpro__tab");
    if(tab){
      root.querySelectorAll(".gxpro__tab").forEach(b=>{
        const on = b === tab;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      setMode(tab.dataset.tab);
      closeMenu();
      return;
    }

    if(act === "toggleSt"){ toggleMenu(); return; }

    const stCard = t.closest("[data-st-item]");
    if(stCard){ setStation(stCard); closeMenu(); return; }

    if(act === "apPrev"){ goPrevPage(); return; }
    if(act === "apNext"){ goNextPage(); return; }

    if(act === "clear"){
      if(mode === "auto") qtyAuto.clear();
      else { cov.clear(); covStep = "pick"; }
      renderAppliances();
      renderCovUsageCards();
      renderCovStations();
      updateCovUI();
      computeAuto();
      return;
    }

    if(act === "qtyDec"){
      battQty = Math.max(0, battQty - 1);
      const qtyEl = bind("qty");
      if(qtyEl) qtyEl.textContent = String(battQty);
      if(mode === "cov" && covStep === "stations") renderCovStations();
      computeAuto();
      updateStationMeta();
      return;
    }
    if(act === "qtyInc"){
      battQty = Math.min(FREEDOM_MAX_BATT, battQty + 1);
      const qtyEl = bind("qty");
      if(qtyEl) qtyEl.textContent = String(battQty);
      if(mode === "cov" && covStep === "stations") renderCovStations();
      computeAuto();
      updateStationMeta();
      return;
    }

    if(act === "covNext"){
      if(mode !== "cov") return;
      if(covStep === "pick"){
        if(!covHasSelection()) return;
        covStep = "usage";
        renderCovUsageCards();
        updateCovUI();
        return;
      }
      if(covStep === "usage"){
        covStep = "stations";
        renderCovStations();
        updateCovUI();
        return;
      }
      return;
    }

    if(act === "covBack"){
      if(mode !== "cov") return;
      if(covStep === "usage"){
        covStep = "pick";
        updateCovUI();
        return;
      }
      if(covStep === "stations"){
        covStep = "usage";
        renderCovUsageCards();
        updateCovUI();
        return;
      }
    }

    if(act === "covRm" || act === "covInc" || act === "covDec" || act === "useInc" || act === "useDec"){
      const card = t.closest(".gxpro__covCard");
      const idx = parseInt(card?.getAttribute("data-cov-idx") || "-1", 10);
      if(idx < 0) return;

      const d = DEVICES[idx];
      const spec = specialUnitForDevice(d.name);
      const obj = cov.get(idx) || { qty: 1, units: 1, unitLabel: spec.unitLabel, minutesPerUnit: spec.minutesPerUnit };

      if(act === "covRm"){
        cov.delete(idx);
        renderAppliances();
        renderCovUsageCards();
        updateCovUI();
        return;
      }

      if(act === "covInc" || act === "covDec"){
        const cur = Number(obj.qty || 0);
        const next = (act === "covInc") ? Math.min(99, cur + 1) : Math.max(0, cur - 1);
        if(next <= 0) cov.delete(idx);
        else cov.set(idx, { ...obj, qty: next });
        renderAppliances();
        renderCovUsageCards();
        updateCovUI();
        return;
      }

      if(act === "useInc" || act === "useDec"){
        const cur = Number(obj.units || 0);
        const next = (act === "useInc") ? Math.min(999, cur + 1) : Math.max(0, cur - 1);
        cov.set(idx, { ...obj, units: next });
        const v = card.querySelector('[data-bind="useVal"]');
        if(v) v.textContent = String(next);
        return;
      }
    }

    const tile = t.closest(".gxpro__tile");
    if(tile){
      const idx = parseInt(tile.getAttribute("data-idx") || "-1", 10);
      if(idx < 0) return;

      const vEl = tile.querySelector(`[data-bind="v-${idx}"]`);
      const twEl = tile.querySelector(`[data-bind="tw-${idx}"]`);

      if(act === "incQty" || act === "decQty"){
        e.preventDefault();
        e.stopPropagation();

        if(mode === "auto"){
          const cur = qtyAuto.get(idx) || 0;
          const next = (act === "incQty") ? Math.min(99, cur + 1) : Math.max(0, cur - 1);
          qtyAuto.set(idx, next);
          if(vEl) vEl.textContent = String(next);
          if(twEl) twEl.textContent = autoQtyLabel(DEVICES[idx], next);
          tile.classList.toggle("is-on", next > 0);
          computeAuto();
          return;
        } else {
  const d = DEVICES[idx];
  const spec = specialUnitForDevice(d.name);
  const obj = cov.get(idx) || { qty: 0, units: 1, unitLabel: spec.unitLabel, minutesPerUnit: spec.minutesPerUnit };

  // ✅ TOGGLE solo en Paso 1 (pick): click = seleccionar/deseleccionar
  if(covStep === "pick"){
    const cur = Number(obj.qty || 0);

    if(cur > 0){
      cov.delete(idx);                 // desmarca
      if(vEl) vEl.textContent = "0";
      tile.classList.remove("is-on");
    } else {
      cov.set(idx, { ...obj, qty: 1 }); // marca
      if(vEl) vEl.textContent = "1";
      tile.classList.add("is-on");
    }

    updateCovUI();
    return;
  }

  // En Paso 2/3 no hagas toggle por click (evitas cagazos)
  return;
}

      }

      if(!t.closest(".gxpro__stepper2")){
        if(mode === "auto"){
          const cur = qtyAuto.get(idx) || 0;
          const next = Math.min(99, cur + 1);
          qtyAuto.set(idx, next);
          if(vEl) vEl.textContent = String(next);
          if(twEl) twEl.textContent = autoQtyLabel(DEVICES[idx], next);
          tile.classList.toggle("is-on", next > 0);
          computeAuto();
          return;
        } else {
          const d = DEVICES[idx];
          const spec = specialUnitForDevice(d.name);
          const obj = cov.get(idx) || { qty: 0, units: 1, unitLabel: spec.unitLabel, minutesPerUnit: spec.minutesPerUnit };

          const next = Math.min(99, Number(obj.qty || 0) + 1);
          cov.set(idx, { ...obj, qty: next });

          if(vEl) vEl.textContent = String(next);
          tile.classList.toggle("is-on", next > 0);

          if(mode === "cov" && covStep === "usage") renderCovUsageCards();
          updateCovUI();
          return;
        }
      }
    }
  });

  document.addEventListener("click", (e) => {
    if(!root.contains(e.target)) return;
    if(!root.querySelector(".gxpro__stSelect")?.contains(e.target) && !stMenu.hidden) closeMenu();
  });

  document.addEventListener("keydown", (e) => {
    if(e.key === "Escape" && !stMenu.hidden) closeMenu();
  });

  attachSwipePager();
  renderAppliances();

  const apTotalEl = bind("apTotal");
  if(apTotalEl) apTotalEl.textContent = "1";

  if(stSelected) setStation(stSelected);
  else {
    const stBtnText = bind("stBtnText");
    if(stBtnText) stBtnText.textContent = "No hay estaciones disponibles";
    if(buyBtn) buyBtn.classList.add("is-disabled");
  }

  if(covPanel) covPanel.hidden = true;
  if(covStationsPanel) covStationsPanel.hidden = true;

  updateCovUI();
  computeAuto();
  updateStationMeta();
})();